document.addEventListener("DOMContentLoaded", function () {
  // Handle burger menu toggle
  const burger = document.querySelector(".header__burger");
  const menu = document.querySelector(".header__nav");

  if (burger && menu) {
    burger.addEventListener("click", function () {
      const isOpen = menu.classList.contains("header__nav--open");
      menu.classList.toggle("header__nav--open");
      burger.classList.toggle("header__burger--open");
      
      // Update aria attributes
      burger.setAttribute("aria-expanded", !isOpen);
    });
  }

  // Handle submenu disclosures
  const disclosureButtons = document.querySelectorAll(".header__menu-disclosure");
  
  disclosureButtons.forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      const submenuId = button.getAttribute("aria-controls");
      const submenu = submenuId ? document.getElementById(submenuId) : null;
      
      if (submenu) {
        // Toggle submenu visibility
        if (isExpanded) {
          submenu.setAttribute("hidden", "");
          button.setAttribute("aria-expanded", "false");
        } else {
          submenu.removeAttribute("hidden");
          button.setAttribute("aria-expanded", "true");
        }
      }
    });
  });
});
